<template>
  <div class="Expander">
    <div class="Expander__trigger" @click="open = !open" :class="open ? 'active' : 'beforeBorder'">
      <div class="form_row mv_0 px-2 cursor-pointer">
          <svg class="nav_caret Expander__trigger-Icon" :class="{ open: open }"><use xlink:href="#caret" /></svg>
        <slot name="title">
          <span class="pt-2 font_bold" v-if="title">{{ title }}</span>
        </slot>
      </div>
    </div>
    <transition :name="animation">
      <div class="tile" v-if="open">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Expander',
  props: {
    isHtml: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: false,
    },
    animation: {
      type: String,
      default: 'bottomToTop',
    },
  },
  emits: ['opened', 'closed'],
  watch: {
    open(newValue) {
      newValue ? this.$emit('opened') : this.$emit('closed')
    }
  }
};
</script>

<style scoped>
.beforeBorder {
  position: relative;
}

.beforeBorder:before {
  transition: opacity 0.1s linear, transform 0.5s ease-in-out;
  position: absolute;
  border-bottom: 1px solid currentColor;
  content: '';
  width: 100%;
  left: 0;
  bottom: -1px;
}

.beforeBorder:not(:hover)::before {
  transform: scaleX(0);
  opacity: 0;
}

.Accordion {
  background: #fff;
  box-shadow: 0 1px 12px 1px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.Expander__trigger {
  cursor: pointer;
  padding: 0.7rem 0.5rem;
  border-bottom: 2px solid var(--light);
  background: var(--table-row-color)
}

.Expander__trigger:hover, .Expander__trigger.active  {
  color: var(--light);
  background: var(--bg-gradient)
}
.Expander__trigger:hover svg {
  fill: var(--light) !important;
}

.Expander__trigger.active {
  border-bottom-color: transparent;
}

.Expander__trigger-Icon {
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  height: 0.5rem;
  width: 0.5rem;
  fill: var(--text);
  opacity: 0.75;
  transform: rotate(90deg);
  order: 2;
}

.Expander__trigger-Icon.open {
  fill: var(--light);
  transform: rotate(-90deg);
  opacity: 1;
}

.Expander__body {
  padding: 1rem 1.5rem;
  background: #eff0f2;
}

.rightToLeft-enter-active {
  animation: rightToLeft 0.5s;
}

.rightToLeft-leave-active {
  animation: rightToLeft 0.5s reverse;
}

.leftToRight-enter-active {
  animation: leftToRight 0.5s;
}

.leftToRight-leave-active {
  animation: leftToRight 0.5s reverse;
}

.bounceIn-enter-active {
  animation: bounceIn 0.3s;
}

.bounceIn-leave-active {
  animation: bottomToTop 0.2s reverse;
}

.bottomToTop-enter-active {
  animation: bottomToTop 0.5s forwards;
}

.bottomToTop-leave-active {
  animation: bottomToTop 0.5s reverse;
}

@keyframes rightToLeft {
  0% {
    transform: translateX(100vw);
  }

  50% {
    transform: translateX(-2em);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes leftToRight {
  0% {
    transform: translateX(-100vw);
  }

  50% {
    transform: translateX(2em);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

@keyframes bottomToTop {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0);
  }
}

</style>
